App.controller('HealthPzuwPackageCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', 'packageService', 'branchService', '$stateParams', 'dataUser', 'healthInsuranceService', 'moment', '$rootScope', function ($scope, $sce, $state, $http, $mdDialog, Config, packageService, branchService, $stateParams, dataUser, healthInsuranceService, moment, $rootScope) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (wybierz pakiet)';
    $scope.$emit('step', $scope.step);

    $state.go('root.health.start');

    healthInsuranceService.getLastActiveDeclaration('PZUW').then(function (data) {
        if (data.status === 200) {
            $scope.last = data.data;
            if ($scope.last) {
                $scope.link = 'root.health.list';
            } else {
                $scope.link = '';
            }
        }
        $scope.$emit('link', $scope.link);
    });

    packageService.dataHealthGroupedPackageLists().then(function (data) {
        $scope.package = data.data.group;
    });

    $scope.userData = dataUser.getLocal();
    $scope.branch = JSON.parse($scope.userData).person.branch;

    function determineProposedDate() {
        let date = new Date();
        let dayOfMonth = date.getDate();
        let requiredDayOfMonth = $rootScope.CONFIGURATOR.healthInsurancePzuw.deliverDeclarationDayLimit;

        if ($rootScope.CONFIGURATOR.healthInsurancePzuw.deliverDeclarationDayLimitException) {
            let exceptionDate = moment($rootScope.CONFIGURATOR.healthInsurancePzuw.deliverDeclarationDayLimitException);
            if (date.getFullYear() === exceptionDate.year() && date.getMonth() === exceptionDate.month() && date.getDate() <= exceptionDate.date()) {
                requiredDayOfMonth = exceptionDate.date();
            }
        }

        if (dayOfMonth <= requiredDayOfMonth) {
            // to najbliższy
            date = new Date(date.getFullYear(), date.getMonth() + 1);
            return moment(date).format('YYYY-MM-DD');
        } else {
            // to +1 miesiąc
            date = new Date(date.getFullYear(), date.getMonth() + 2);
            return moment(date).format('YYYY-MM-DD');
        }
    }

    $scope.proposedDate = determineProposedDate();
}]);
